import { TextStyle } from './types'
import { TextProps } from './Text'

export const textPropsByTextStyle: Record<TextStyle, TextProps> = {
  'page-section-heading': {
    fontSize: 14,
    fontWeight: 700,
  },
  'page-heading': {
    fontSize: 16,
    fontWeight: 600,
  },
  'multiline-body-tight': {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 4,
  },
  'multiline-body': {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 8,
  },
  'form-value-multiline': {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 8,
  },
  'monoline-body-emphasis': {
    fontSize: 14,
    fontWeight: 600,
  },
  'monoline-body': {
    fontSize: 14,
    fontWeight: 500,
  },
  cell: {
    fontSize: 14,
    fontWeight: 500,
  },
  'modal-heading': {
    fontSize: 20,
    fontWeight: 600,
  },
  'list-group-heading': {
    fontSize: 14,
    fontWeight: 600,
  },
  'item-unselected': {
    fontSize: 14,
    fontWeight: 500,
  },
  'item-selected': {
    fontSize: 14,
    fontWeight: 600,
  },
  'form-label': {
    fontSize: 12,
    fontWeight: 600,
  },
  'detail-emphasis': {
    fontSize: 12,
    fontWeight: 600,
  },
  'detail-caps': {
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  detail: {
    fontSize: 12,
    fontWeight: 500,
  },
  'code-inline': {
    fontFamily: 'monospace',
    fontSize: 14,
    fontWeight: 400,
  },
  'code-block': {
    fontFamily: 'monospace',
    lineHeight: 4,
    fontSize: 14,
    fontWeight: 400,
  },
  'cell-heading': {
    fontSize: 14,
    fontWeight: 600,
  },
  button: {
    fontSize: 12,
    fontWeight: 500,
  },
}
